var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");require("./camel_snake_kebab.internals.string_separator.js");require("./clojure.string.js");
'use strict';